module.exports = __webpack_public_path__ + "img/xcx.57935638.jpg";